import { Surface } from '../terrain';

/**
 * How each surface resists a rolling wheel, on top of its grip (SURFACE_GRIP in terrain.ts).
 * - roll: rolling resistance as a fraction of the wheel load.
 * - sink: soft ground; extra resistance grows with load squared (a loaded wheel sinks deeper and ploughs),
 *   so weight thrown onto the front in sand digs it in, and a light front (drive) floats.
 * - wander: front-tyre deflection in loose ground, fraction of the load, from a fixed noise field (deterministic).
 */
export interface SurfaceFeel { roll: number; sink: number; wander: number }

export const SURFACE_FEEL: Record<Surface, SurfaceFeel> = {
  clay: { roll: 0, sink: 0, wander: 0 },
  sandClay: { roll: 0.01, sink: 0.01, wander: 0.02 },
  mud: { roll: 0.04, sink: 0.05, wander: 0.04 },
  sand: { roll: 0.05, sink: 0.12, wander: 0.18 },
  grass: { roll: 0.01, sink: 0, wander: 0.01 },
  roots: { roll: 0.02, sink: 0, wander: 0.08 },
  water: { roll: 0.08, sink: 0.08, wander: 0.05 },
};

/** Noise feature size (m) of the sand wander field. */
export const WANDER_SCALE = 1.6;
